import * as React from 'react'
import { sourceSearchPlaceholder } from '@chegg-wt/core/utils/searchSources'
import { SourceType } from '@chegg-wt/core/types/core'
import {
  CITATION_SEARCH_BAR,
  CITATION_SEARCH_INPUT,
  CITATION_SEARCH_BUTTON,
} from '../utils/testIds'
import WorldCatLink from '../WorldCatLink'
import { SearchLabel, WorldCatSmall } from '../styled'
import { SearchButton, SearchForm, InputContainer, SearchInput } from './styled'

interface SourceSearchBarProps {
  onSearchQueryUpdate: (text: string) => void
  searchQuery: string
  isWorldCatSource: boolean
  sourceType: SourceType
}

export const EMPTY_SEARCH_QUERY_ERROR = 'Please add information in the search bar'

const SourceSearchBar = ({
  onSearchQueryUpdate,
  searchQuery,
  isWorldCatSource,
  sourceType,
}: SourceSearchBarProps) => {
  const [text, setText] = React.useState(searchQuery)
  const [hasEmptyTextError, setHasEmptyTextError] = React.useState(false)

  React.useEffect(() => {
    if (hasEmptyTextError && text && text.trim()) {
      setHasEmptyTextError(false)
    }
  }, [hasEmptyTextError, text])

  const onFormSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault()

    if (!text || !text.trim()) {
      setHasEmptyTextError(true)
      return
    }

    setHasEmptyTextError(false)
    onSearchQueryUpdate(text)
  }

  const placeholder = () => {
    return sourceSearchPlaceholder[sourceType?.id] || sourceSearchPlaceholder.default
  }

  return (
    <SearchForm onSubmit={onFormSubmit} data-test={CITATION_SEARCH_BAR}>
      <InputContainer>
        <SearchLabel htmlFor="search-input">Search</SearchLabel>
        <SearchInput
          id="search-input"
          data-test={CITATION_SEARCH_INPUT}
          width="100%"
          type="text"
          value={text}
          inputSize="medium"
          onChange={(e) => setText(e.target.value)}
          error={hasEmptyTextError ? EMPTY_SEARCH_QUERY_ERROR : null}
          placeholder={placeholder()}
        />
      </InputContainer>
      {isWorldCatSource && (
        <WorldCatSmall>
          <WorldCatLink />
        </WorldCatSmall>
      )}
      <SearchButton
        type="submit"
        isHoverAnimated={false}
        data-test={CITATION_SEARCH_BUTTON}
        hasError={hasEmptyTextError}
      >
        {' '}
        Search
      </SearchButton>
    </SearchForm>
  )
}

export default SourceSearchBar
